import { createAction, props } from '@ngrx/store';
import { EstruturaRetornoDadosOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto';
import { SobreJornalOutputDto } from 'src/app/domain/DTOs/output/sobre/sobre-jornal.output.dto';

const actionName = "[ ObterSobre ] Obter Sobre";

export const obterSobre = createAction(
  actionName
);

export const obterSobreSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<SobreJornalOutputDto> }>()
);
